export enum CouponState {
    INITIAL = '',
    CLEARED = 'cleared',
    VALID = 'valid',
    INVALID = 'invalid',
    ELIGIBLE = 'eligible',
    INELIGIBLE = 'ineligible',
    EXPIRED = 'expired',
    BACKEND_ERROR = 'backend_error',
    THRESHOLD_NOT_MET = 'threshold_not_met'
}
